import { useEffect, useState } from "react";
import { Images, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/crm/Badges";
import { ImageUploader } from "@/components/crm/admin/ImageUploader";

const SLOTS = [
  ["hero", "Hero principal", "Foto grande de la portada. Recomendado horizontal, mín. 1600 px de ancho.", "aspect-[5/4]",
    [{ key: "hero", label: "Escritorio", aspect: "5/4" }, { key: "hero_mobile", label: "Móvil", aspect: "4/3", narrow: true }],
    [{ label: "Escritorio", aspect: "5/4", target: "hero" }, { label: "Móvil", aspect: "4/3", target: "hero_mobile", narrow: true }]],
  ["facility", "Instalaciones (sección institucional)", "Foto de la sección «Sobre nosotros». Recomendado horizontal 4:3.", "aspect-[4/3]",
    [{ key: "facility", label: "Escritorio y móvil", aspect: "4/3" }], []],
];
const framingOf = (v, targets) => Object.fromEntries(targets.map((t) => [t.key, v[`${t.key}_framing`]]));
const framingPatch = (d) => Object.fromEntries(Object.entries(d).map(([k, f]) => [`${k}_framing`, f]));

export const SiteImagesPanel = () => {
  const [v, setV] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/site-images").then((r) => setV(r.data)).catch(() => setV({})); }, []);
  if (!v) return null;
  const save = async () => {
    setSaving(true);
    try { setV((await api.put("/admin/site-images", v)).data); toast.success("Imágenes del sitio guardadas"); }
    catch (e) { toast.error(errorMessage(e)); } finally { setSaving(false); }
  };
  return (
    <Panel title="Imágenes del sitio" icon={Images} className="mt-6" testid="site-images-panel">
      <p className="text-sm text-slate-600">Si no subes una imagen, el sitio usa la foto actual.</p>
      <div className="mt-4 grid gap-6 md:grid-cols-2">
        {SLOTS.map(([k, title, hint, aspect, targets, previews]) => (
          <div key={k}>
            <p className="text-sm font-semibold text-[#0B2545]">{title}</p>
            <p className="mb-2 text-xs text-slate-500">{hint}</p>
            <ImageUploader value={v[k] || ""} kind={k} aspect={aspect} testid={`site-image-${k}`}
              onChange={(url, fr) => setV((s) => ({ ...s, [k]: url || null, ...framingPatch(Object.fromEntries(targets.map((t) => [t.key, fr || null]))) }))}
              framing={framingOf(v, targets)} onFramingChange={(d) => setV((s) => ({ ...s, ...framingPatch(d) }))}
              targets={targets} previews={previews} />
          </div>
        ))}
      </div>
      <Button onClick={save} disabled={saving} className="mt-5 rounded-xl bg-[#1E6FD9]" data-testid="site-images-save">
        {saving && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />} Guardar imágenes
      </Button>
    </Panel>
  );
};
